import React, { useEffect, useState } from 'react'
import { Card, CardHeader, Col, Container, Input, Label, Nav, NavItem, NavLink, Navbar, Row, TabContent, TabPane } from 'reactstrap'
import DailyReporting from './DailyReporting';
import Layout from 'HorizontalMenu/Menu';
import { RootState } from 'index';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { setVesselID } from 'Store/Generic/ReportingSlice';
import Flatpickr from "react-flatpickr";
import { loadVesselYear, voyageList } from 'VesselMaster/vesselMaster.hooks';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import classnames from 'classnames';
import VerifierReporting from './VerifierReporting';

const ReportGeneration = () => {
    /** State variables */
    const dispatch = useDispatch();
    const { Vessels, VesselID } = useSelector((state: RootState) => state.Reporting);
    const [dateBoolean, setDateBoolean] = useState(false);
    const [voyageBoolean, setVoyageBoolean] = useState(false);
    const [yearBoolean, setYearBoolean] = useState(true);
    const [vesselBoolean, setVesselBoolean] = useState(false);
    const [count, setCount] = useState(0);
    const [activeSettingsTab, setActiveSettingsTab] = useState('1');
    /** State variables end */

    /** Queries start */
    const { data: voyages } = useQuery([queryKeyes.vessel.VoyageList.key, VesselID],
        async () => await voyageList(VesselID), {
        staleTime: 600000
    })
    /** Queries end */

    /** Set vessel id globally */
    const handleVesselSelectionChanges = (e: any) => {
        dispatch(setVesselID(e.id));
    }

    /** Change vertical tabs */
    const toggle = (tab: any) => {
        if (activeSettingsTab !== tab) {
            if (tab === '3' || tab === '4') {
                setVesselBoolean(true);
            } else {
                setVesselBoolean(false);
            }
            setActiveSettingsTab(tab);
        }
    }

    /** useEffect start */
    useEffect(() => {
        setCount(count + 1);
    }, [VesselID])
    /** useEffect end */

    return (
        <>
            <Layout children={Navbar} />
            <Container fluid>
                <Row className='mt-3 mb-3'>
                    <h4>Report Generation</h4>
                </Row>
                <Row className='mb-3'>
                    <Col lg={4}>
                        <Label className='mb-0'>Select vessel</Label>
                        <Select
                            options={Vessels.filter((item: any) => item.display === true)}
                            getOptionLabel={option => option.vessel_name}
                            getOptionValue={option => option.id}
                            onChange={(e: any) => handleVesselSelectionChanges(e)}
                        />
                    </Col>
                </Row>
                {!vesselBoolean &&
                    <Row className='mb-4'>
                        <Col lg={4}>
                            <div className='ele_row1'>
                                <Input
                                    type='checkbox'
                                    name='year_checkbox'
                                    id='year_checkbox'
                                    onChange={(e: any) => {
                                        setYearBoolean(e.target.checked);
                                        setVoyageBoolean(!e.target.checked);
                                        setDateBoolean(!e.target.checked);
                                    }}
                                    checked={yearBoolean}
                                />
                                <div className='ml-1'>
                                    <Label className='mb-0'>Select year</Label>
                                    {yearBoolean &&
                                        <AsyncSelect
                                            key={count}
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={() => loadVesselYear(VesselID)}
                                            getOptionLabel={(option: any) => option.year}
                                            getOptionValue={(option: any) => option.year}
                                            className='min-width-20'
                                        />
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='ele_row1'>
                                <Input
                                    type='checkbox'
                                    name='date_checkbox'
                                    id='date_checkbox'
                                    onChange={(e: any) => {
                                        setDateBoolean(e.target.checked);
                                        setVoyageBoolean(!e.target.checked);
                                        setYearBoolean(!e.target.checked);
                                    }}
                                    checked={dateBoolean}
                                />
                                <div>
                                    <Label className='mb-0 ml-1'>Select date range</Label>
                                    {dateBoolean &&
                                        <Flatpickr
                                            className="form-control d-block ml-1 min-width-20"
                                            placeholder="DD-MM-YYYY"
                                            options={{
                                                mode: "range",
                                                dateFormat: "Y-m-d",
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='ele_row1'>
                                <Input
                                    type='checkbox'
                                    name='voyage_checkbox'
                                    id='voyage_checkbox'
                                    onChange={(e: any) => {
                                        setVoyageBoolean(e.target.checked);
                                        setDateBoolean(!e.target.checked);
                                        setYearBoolean(!e.target.checked);
                                    }}
                                    checked={voyageBoolean}
                                />
                                <div className='ml-1'>
                                    <Label className='mb-0'>Select voyages</Label>
                                    {voyageBoolean &&
                                        <Select
                                            options={voyages && voyages?.filter((item: any) => item.display === true && (item.voyage_status === 2 || item.voyage_status === 1))}
                                            getOptionLabel={(option: any) => option.voyage_number}
                                            getOptionValue={(option: any) => option.id}
                                            className='min-width-20'
                                            isMulti
                                        />
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                }
                <Row>
                    <Card>
                        <CardHeader className='pb-0'>
                            <Nav tabs className='no-border'>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "1",
                                        })}
                                        onClick={() => {
                                            toggle("1");
                                        }}
                                    >
                                        Daily Reporting
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "2",
                                        })}
                                        onClick={() => {
                                            toggle("2");
                                        }}
                                    >
                                        Verifier Reporting
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "3",
                                        })}
                                        onClick={() => {
                                            toggle("3");
                                        }}
                                    >
                                        Vessel Analysis
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "4",
                                        })}
                                        onClick={() => {
                                            toggle("4");
                                        }}
                                    >
                                        Emission Report
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </CardHeader>
                        <TabContent activeTab={activeSettingsTab}>
                            <TabPane tabId="1" className='margin-3'>
                                <DailyReporting />
                            </TabPane>
                            <TabPane tabId="2" className='margin-3'>
                                <VerifierReporting />
                            </TabPane>
                        </TabContent>
                    </Card>
                </Row>
            </Container>
        </>
    )
}

export default ReportGeneration